var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.errorPageIsVisible)?_c('error-view',{attrs:{"title":_vm.errorPageTitle,"content":_vm.errorPageContent}}):_vm._e(),_vm._v(" "),(_vm.loaderIsVisible && !_vm.errorPageIsVisible)?_c('loader-view',{attrs:{"content":_vm.loaderContent}}):_vm._e(),_vm._v(" "),(!_vm.loaderIsVisible && !_vm.errorPageIsVisible)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }